import jwtDecode from 'jwt-decode';
import axios from './axios';
import { ILoginForm } from './login';
import Cookies from 'universal-cookie';

// ----------------------------------------------------------------------

const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }
  const exp = decode(accessToken)?.exp;
  const currentTime = Date.now() / 1000;
  return exp ? exp > currentTime : false;
};

const decode = (accessToken: string): ILoginForm => {
  return jwtDecode(accessToken);
};

const boostAmpAuthToken: string = encodeURIComponent('boostAmpAuthToken');

const boostAmpRefreshToken: string = encodeURIComponent('boostAmpRefreshToken');

const cookies = new Cookies();

const getAuthTokenCookie = (): string => {
  return cookies.get(boostAmpAuthToken);
};

const getRefreshTokenCookie = (): string => {
  return cookies.get(boostAmpRefreshToken);
};

const cleanSession = () => {
  deleteCookie();
  //along with deleting the cookie also delete the userInfo from local storage
  localStorage.removeItem('UserInfo');
  // We need to wait half second to reload the page and delete the cookie.
  delete axios.defaults.headers.common.Authorization;
  // To erase the cookie completely need to reload the page.
  setTimeout(() => {
    location.reload();
  }, 500);
};

const setSession = (accessToken: string, refreshToken: string) => {
  if (accessToken && refreshToken) {
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    setCookie(accessToken, refreshToken);
  } else cleanSession();
};

const getTimeLeft = (accessToken: string): number => {
  const { exp } = decode(accessToken);
  if (exp) {
    const currentTime = Date.now() / 1000;
    const timeLeft = exp - currentTime;
    return Math.floor(timeLeft);
  }
  return 0;
};

// Token Section
const setCookie = (accessToken: string, refreshToken: string) => {
  cookies.set(boostAmpAuthToken, encodeURIComponent(accessToken), {
    sameSite: 'strict',
    maxAge: getTimeLeft(accessToken),
    path: '/'
  });
  cookies.set(boostAmpRefreshToken, encodeURIComponent(refreshToken), {
    sameSite: 'strict',
    maxAge: getTimeLeft(refreshToken),
    path: '/'
  });
};

/**
 * Validates if a token exist in the cookies.
 * @param name          Cookie name
 * @param defaultValue  The value to return if no cookie is found
 */
const validateToken = () => {
  //get token cookie
  const accessToken = getAuthTokenCookie();
  if (accessToken) {
    const timeLeft = getTimeLeft(accessToken);
    //if token expired clean session
    if (timeLeft <= 0) {
      cleanSession();
      return false;
    }
    return true;
  }
  return false;
};

/**
 * Delete the cookie when we logout from the application.
 */
const deleteCookie = () => {
  const authToken = getAuthTokenCookie();
  if (authToken) {
    cookies.remove(boostAmpAuthToken, { path: '/' });
  }
  const refreshToken = getRefreshTokenCookie();
  if (refreshToken) {
    cookies.remove(boostAmpRefreshToken, { path: '/' });
  }
};

export {
  isValidToken,
  decode,
  setSession,
  setCookie,
  validateToken,
  getAuthTokenCookie,
  getRefreshTokenCookie,
  cleanSession
};
